import React from 'react'

export const preventEnterKey = (event: React.KeyboardEvent) => {
    if (event.keyCode === 13 ) {
      event.preventDefault()
    }
}

export const encryptPhone = (phone?: string) => {
  if (!phone) return ''
  return `****${phone.substr(-4)}`
}

export const currencyFormat = (numOrStr?: string | number) => {
  if (typeof numOrStr === 'undefined') return numOrStr
  return Number(numOrStr).toLocaleString('en')
}

export const lockBody = (lock: boolean) => {
  const type = lock ? 'add' : 'remove'
  document.body.classList[type]('fixed')
}